
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/subscription/[...path]",
      function () {
        return require("private-next-pages/s/subscription/[...path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/subscription/[...path]"])
      });
    }
  